import React from "react"
import { View, TouchableOpacity, StyleSheet, Text } from "react-native"
import { theme } from "@common/theme/theme"
import { formatEuros } from "../utils/formatEuros"

/**
 * @param discount = pourcentage urgence midnight (toujours actif sur le funnel) :
 *   le prix affiché est `formula.price`, le prix barré = `formula.price * 2`
 * @param referralActive = -50 % filleul en plus :
 *   le prix affiché = `formula.price / 2`, le prix barré = `formula.price`
 * @param disabled = formule non commercialisée sur la phase de booking active
 *   (ex: Sprint/Intensif en phase "Coup de pouce only"). Carte grisée +
 *   badge "Complet", non cliquable. Prend le pas sur `recommended`.
 */
const BrevetFormulaCard = ({
    formula,
    selected,
    recommended,
    onPress,
    style,
    discount,
    referralActive,
    disabled,
}) => {
    let displayedPrice = formula.price
    let originalPrice = null
    if (referralActive) {
        displayedPrice = formula.price / 2
        originalPrice = formula.price
    } else if (discount) {
        originalPrice = formula.price * 2
    }
    return (
        <TouchableOpacity
            onPress={disabled ? undefined : onPress}
            activeOpacity={disabled ? 1 : 0.85}
            disabled={disabled}
            style={[
                styles.card,
                selected && !disabled && styles.cardSelected,
                disabled && styles.cardDisabled,
                style,
            ]}
        >
            {disabled ? (
                <View style={styles.completBadge}>
                    <Text style={styles.completText}>COMPLET</Text>
                </View>
            ) : recommended ? (
                <View style={styles.recommendedBadge}>
                    <Text style={styles.recommendedText}>RECOMMANDÉ</Text>
                </View>
            ) : null}
            <View style={styles.row}>
                <View style={{ flex: 1 }}>
                    <Text style={[styles.name, disabled && styles.textDisabled]}>
                        {formula.label}
                    </Text>
                    <Text style={[styles.meta, disabled && styles.textDisabled]}>
                        {formula.hours}h — {formula.weekends} week-end
                        {formula.weekends > 1 ? "s" : ""}
                    </Text>
                </View>
                <View style={styles.priceColumn}>
                    {originalPrice !== null && !disabled ? (
                        <Text style={styles.priceStrike}>
                            {formatEuros(originalPrice)}
                        </Text>
                    ) : null}
                    <Text style={[styles.price, disabled && styles.textDisabled]}>
                        {formatEuros(displayedPrice)}
                    </Text>
                </View>
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    card: {
        position: "relative",
        borderWidth: 1.5,
        borderColor: theme.colors.lightMore,
        borderRadius: 14,
        padding: 14,
        backgroundColor: theme.colors.white,
        marginBottom: 10,
    },
    cardSelected: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primaryLighter,
    },
    cardDisabled: {
        backgroundColor: theme.colors.lighter,
        borderColor: theme.colors.lightMore,
        opacity: 0.65,
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
    },
    recommendedBadge: {
        position: "absolute",
        top: -8,
        right: 12,
        backgroundColor: theme.colors.success,
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
        zIndex: 1,
    },
    recommendedText: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 9,
        color: theme.colors.white,
        letterSpacing: 0.5,
    },
    completBadge: {
        position: "absolute",
        top: -8,
        right: 12,
        backgroundColor: theme.colors.grey,
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
        zIndex: 1,
    },
    completText: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 9,
        color: theme.colors.white,
        letterSpacing: 0.5,
    },
    name: {
        fontFamily: "Montserrat-Bold",
        fontSize: 15,
        color: theme.colors.grey,
    },
    meta: {
        fontFamily: "Montserrat-Medium",
        fontSize: 12,
        color: theme.colors.light,
        marginTop: 2,
    },
    textDisabled: {
        color: theme.colors.light,
    },
    priceColumn: {
        alignItems: "flex-end",
    },
    priceStrike: {
        fontFamily: "Montserrat-Regular",
        fontSize: 13,
        color: theme.colors.light,
        textDecorationLine: "line-through",
    },
    price: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 20,
        color: theme.colors.primary,
    },
})

export default BrevetFormulaCard
